<template lang="pug">
  validation-observer(ref='observer' tag='form')
    header
      main-header(
        :notificacao="false"
        :hasListagemModelo="false"
      )
    .content-route-view
      el-card.card
        h1(v-if="!isEdicao") Cadastro de usuário
        h1(v-else) Edição de usuário
        el-row.margin-top( type="flex", justify="start")
          el-radio-group(v-if="!tipoChanged" v-model="setPessoaTipo" :disabled="isEdicao")
            el-radio-button(label='PF')
              i.fal.fa-user
              |  Pessoa Física
            el-radio-button(label='PJ')
              i.fal.fa-building
              |  Pessoa Jurídica
        app-divider(
          v-if="!isEdicao && !isExterno"
          label="Dados do usuário"
        )

        el-row.margin-top-15(v-if="!isEdicao && !isExterno")
          el-col(:span="12")
            app-input-perfil(v-if="!tipoChanged" v-model="usuario.perfis", :usuarioTipo="pessoa.tipo", @perfilAdicionado="perfilAdicionado")
            div(v-if="hasTecnicoMunicipal").margin-top-15
              validation-provider(rules="required", v-slot="{ errors }")
                app-label(label="Prefeitura:")
                el-select.full-width.input(
                  v-model='idMunicipio'
                  :class="{'erro' : errors.length}"
                )
                  el-option(
                      v-for='municipio in municipios'
                      :key='municipio.id',
                      :label='municipio.nome'
                      :value='municipio.id'
                  )
                span.help.erro {{ errors[0] }}
        el-row
          app-divider(
            :label="pessoa.tipo == 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'"
          )

        el-row.margin-top-15(
          :gutter="30",
          type="flex",
          v-if="pessoa.tipo === 'PF'",
          key="pessoaFisica"
        )
          el-col.boxInput(:span="12")
            validation-provider(mode="lazy", rules="required|cpf_cnpj", v-slot="{ errors }", name="cadastroUsuario/cpf")
              app-label(
                label="CPF:",
                :required="true"
              )
              el-input.input(
                v-mask="['###.###.###-##']",
                :class="{'erro' : errors.length}",
                v-model="pessoa.pessoaFisica.cpf",
                @blur="buscarDados",
                suffix-icon="el-icon-search"
                :disabled="isEdicao"
              )
              span.help.erro {{ errors[0] }}
          el-col.boxInput(:span="12")
            validation-provider(mode="lazy", rules="required", v-slot="{ errors }", name="cadastroUsuario/nome")
              app-label(
                label="Nome:",
                :required="true"
              )
              el-input.input(
                v-model="pessoa.pessoaFisica.nome",
                @blur="toUpperCase",
                :class="{'erro' : errors.length}",
                :maxlength="maxLengthNome"
              )
              span.help.erro {{ errors[0] }}
        el-row.margin-top-15(
          :gutter="30",
          type="flex",
          v-else,
          key="pessoaJuridica"
        )
          el-col.boxInput(:span="12")
            validation-provider(mode="lazy", rules="required|cpf_cnpj", v-slot="{ errors }", name="cadastroUsuario/cnpj")
              app-label(
                label="CNPJ:",
                :required="true"
              )
              el-input.input(
                v-mask="['##.###.###/####-##']",
                v-model="pessoa.pessoaJuridica.cnpj",
                :class="{'erro' : errors.length}",
                @blur="buscarDados",
                suffix-icon="el-icon-search",
                :disabled="isEdicao"
              )
              span.help.erro {{ errors[0] }}
          el-col.boxInput(:span="12")
            validation-provider(mode="lazy", rules="required", v-slot="{ errors }", name="cadastroUsuario/razaoSocial")
              app-label(
                label="Razão Social:",
                :required="true"
              )
              el-input.input(
                v-model="pessoa.pessoaJuridica.razaoSocial"
                @blur="toUpperCase",
                :class="{'erro' : errors.length}",
                :maxlength="maxLengthRazaoSocial",
              )
              span.help.erro {{ errors[0] }}
        el-row.margin-top-15(:gutter="30")
          el-col.boxInput(:span="12")
            validation-provider(mode="lazy", rules="required|email", v-slot="{ errors }", name="cadastroUsuario/email")
              app-label(
                label="E-mail:",
                :required="true"
              )
              el-input.input(
                v-model="pessoa.email",
                :class="{'erro' : errors.length}",
                :maxlength="maxLengthEmail",
              )
              span.help.erro {{ errors[0] }}
          el-col.boxInput(:span="12")
            validation-provider(mode="lazy", rules="required|email_confirmation:@cadastroUsuario/email", v-slot="{ errors }", name="cadastroUsuario/emailConfirmacao")
              app-label(
                label="Confirmar e-mail:",
                :required="true"
              )
              el-input.input(
                v-model="pessoa.confirmaEmail",
                :class="{'erro' : errors.length}",
                :maxlength="maxLengthEmail",
              )
              span.help.erro {{ errors[0] }}

        el-row.margin-top-15(:gutter="30")
          el-col.boxInput(:span="12")
            app-input-telefone(
              :telefones="usuario.pessoa.telefones",
              :requiredTelefones="true",
              :nomeAba="isEdicao ? 'editUser' : 'createUser'",
              :observer="this.$refs.observer"
            )
        app-endereco(
          :endereco="usuario.pessoa.endereco"
          nomeAba="cadastroUsuario",
          :disabledFields="disableEndereco",
          :upperCaseApply="true",
          :codigoEstado="usuario.pessoa.endereco.municipio.codigoEstado"
          :municipio="usuario.pessoa.endereco.municipio"
        )
        el-row.margin-top.footer(type="flex", justify="start")
          el-button(@click="cancelar" class="cancelarButton")
            i.fas.fa-times
            |  Cancelar
          el-button(type='primary', @click="cadastrar()")
            i.fas.fa-check
            |  {{!isEdicao ? 'Cadastrar' : 'Salvar'}}

</template>

<script>
import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import AppInputPerfil from '@/screens/portal/seguranca/components/AppInputPerfil.vue'
import MainHeader from '@/components/MainHeader'
import AppEndereco from '@/screens/portal/seguranca/components/AppEndereco'
import AppInputTelefone from '@/components/AppInputTelefone'

export default {

  components: {
    AppDivider,
    AppLabel,
    AppEndereco,
    MainHeader,
    AppInputPerfil,
    AppInputTelefone
  },

  mixins: [
    AppNotificacao
  ],

  beforeRouteEnter (to, from, next) {
    if (to.params.tipo === 'externo') {
      next()
    } else {
      to.meta.isPublic = false
      next()
    }
  },

  beforeRouteLeave (to, from, next) {
    from.meta.isPublic = true
    next()
  },

  data () {
    return {
      enderecoIterpa: '',
      disableEndereco: false,
      maxLengthRazaoSocial: 200,
      maxLengthEmail: 200,
      maxLengthNome: 300,

      codigoEstadoIterpa: null,
      municipioIterpa: null,

      tipoChanged: false,
      isEdicao: false,

      usuario: {
        municipioPrefeitura: null,
        pessoa: {
          tipo: 'PF',
          pessoaFisica: {
            nome: '',
            cpf: ''
          },
          pessoaJuridica: {
            razaoSocial: '',
            cnpj: ''
          },
          endereco: {
            logradouro: '',
            numero: null,
            semNumero: false,
            complemento: '',
            bairro: '',
            cep: '',
            municipio: {
              id: '',
              codigoEstado: ''
            }
          },
          email: '',
          confirmaEmail: '',
          telefones: []
        },
        perfis: []
      },
      idMunicipio: null,
      municipios: []
    }
  },

  async mounted () {
    // Recuperando endereco padrao do iterpa para fins de registro
    this.enderecoIterpa = await this.findEnderecoById(0)

    if (this.$route.params.cpfCnpj) {
      this.usuario = await this.findUsuarioByCpfCnpj(this.$route.params.cpfCnpj)
      this.usuario.pessoa.telefones = this.usuario.pessoa.telefones.map(item => item.numero)
      this.usuario.pessoa.confirmaEmail = this.usuario.pessoa.email

      this.isEdicao = true
    } else {
      this.usuario.pessoa.telefones = []
    }

    if (this.usuario?.municipioPrefeitura) {
      this.idMunicipio = this.usuario?.municipioPrefeitura?.id
    }

    this.municipios = await this.findMunicipiosByEstadoAtual() || []
  },

  computed: {

    isExterno () {
      return this.$route.params.tipo === 'externo'
    },

    pessoa () {
      return this.usuario.pessoa
    },

    isPessoaJuridica () {
      return this.pessoa.tipo === 'PJ'
    },

    isPessoaFisica () {
      return this.pessoa.tipo === 'PF'
    },

    setPessoaTipo: {
      get () {
        return this.pessoa.tipo
      },
      set (value) {
        this.tipoChanged = true
        this.confirmBox(this.$messages.CADASTRO_ALTERAR_TIPO_PESSOA, this.$messages.TITULO_WARNING,
          async () => {
            if (value === 'PJ') {
              this.pessoa.pessoaFisica.cpf = ''
              this.pessoa.pessoaFisica.nome = ''
            } else {
              this.pessoa.pessoaJuridica.cnpj = ''
              this.pessoa.pessoaJuridica.razaoSocial = ''
            }
            this.pessoa.email = ''
            this.pessoa.confirmaEmail = ''
            this.pessoa.tipo = value
            this.pessoa.endereco = {
              logradouro: '',
              numero: null,
              semNumero: false,
              complemento: '',
              bairro: '',
              cep: '',
              municipio: {
                id: '',
                codigoEstado: ''
              }
            }
            this.pessoa.telefones = []
            this.usuario.perfis = []

            this.tipoChanged = false
            this.$refs.observer.reset()
          },
          () => { this.tipoChanged = false }
        )
      }
    },

    hasTecnicoMunicipal () {
      return this.usuario?.perfis?.find(perfil => perfil.codigo === 'TECNICO_MUNICIPAL')
    }
  },

  methods: {

    ...mapActions({
      cadastrarUsuario: 'usuario/cadastrarUsuario',
      findUsuarioByCpfCnpj: 'usuario/findUsuarioByCpfCnpj',
      findEnderecoById: 'endereco/findEnderecoIterpa',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtualPromise'
    }),

    async buscarDados () {
      const cpfCnpj = this.usuario.pessoa.tipo === 'PF' ? this.usuario.pessoa.pessoaFisica.cpf
        : this.usuario.pessoa.pessoaJuridica.cnpj

      if (cpfCnpj) {
        const result = await this.findUsuarioByCpfCnpj(cpfCnpj)

        if (result) {
          if (this.usuario.pessoa.tipo === 'PF') {
            this.usuario.pessoa.pessoaFisica.cpf = ''
          } else {
            this.usuario.pessoa.pessoaJuridica.cnpj = ''
          }

          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            'O usuário já está cadastrado.'
          )
          this.$refs.observer.reset()
        }
      }
    },

    async cadastrar () {
      // Atenção: workaround para contornar problema na validação do componente de telefone.
      delete this.$refs.observer.refs['$ignoreTelefone$']
      if (this.idMunicipio) {
        this.usuario.municipioPrefeitura = {id: this.idMunicipio}
      }
      if (await this.$refs.observer.validate()) {
        if (!this.isEdicao) {
          this.confirmBox(this.$messages.FINALIZAR_CADASTRO_USUARIO, this.$messages.TITULO_WARNING,
            async () => {
              this.usuario.pessoa.telefones = this.usuario.pessoa.telefones.map(item => ({ numero: item }))

              await this.cadastrarUsuario({ usuario: this.usuario, isExterno: this.isExterno })

              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.CADASTRO_USUARIO_SUCESSO
              )

              this.$router.push({
                name: this.isExterno ? 'login' : 'portalSeguranca/administradorAcesso'
              })
            },
            () => {}
          )
        } else {
          this.usuario.pessoa.telefones = this.usuario.pessoa.telefones.map(item => ({ numero: item }))

          await this.cadastrarUsuario({ usuario: this.usuario, isExterno: this.isExterno })

          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.EDICAO_CADASTRO_SUCESSO
          )

          this.$router.push({
            name: 'portalSeguranca/administradorAcesso'
          })
        }
      } else {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.PREENCHA_TODOS_CAMPOS
        )
      }
    },

    cancelar () {
      this.confirmBox(this.$messages.CANCELAR_CADASTRO, this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: this.isExterno ? 'login' : 'portalSeguranca/administradorAcesso'
          })
        },
        () => {}
      )
    },

    isUsuarioInterno () {
      const codigoSetores = this.usuario.perfis.map(perfil => perfil.setor ? perfil.setor.codigo : '')
      return (this.isEdicao && !codigoSetores.includes('EXTERNO')) && !this.isExterno
    },

    toUpperCase (event) {
      if (this.pessoa.tipo === 'PF') {
        this.pessoa.pessoaFisica.nome = this.pessoa.pessoaFisica.nome.toUpperCase()
      } else {
        this.pessoa.pessoaJuridica.razaoSocial = this.pessoa.pessoaJuridica.razaoSocial.toUpperCase()
      }
    },

    justPerfilInterno (setores) {
      let has = true
      setores.forEach(setor => {
        if (setor.codigo !== undefined) {
          if ((setor.codigo === 'AGENDAMENTO' || setor.codigo === 'EXTERNO' || setor.codigo === 'PREFEITURA' || this.hasTecnicoMunicipal)) {
            has = false
          }
        }
      })

      return has
    },

    hasSomeOneExterno (setores) {
      let has = false
      setores.forEach(setor => {
        if (setor.codigo !== undefined) {
          if (setor.codigo === 'AGENDAMENTO' && setor.codigo === 'EXTERNO' && setor.codigo === 'PREFEITURA') {
            has = true
          }
        }
      })

      return has
    },

    resetEndereco () {
      const endereco = {
        bairro: '',
        cep: '',
        complemento: '',
        logradouro: '',
        municipio: {
          codigoEstado: '',
          id: ''
        },
        numero: null,
        semNumero: false
      }
      this.usuario.pessoa.endereco = endereco
    },

    perfilAdicionado (perfil) {
      if (
        this.usuario.perfis.length > 0 &&
        (perfil.codigo === 'AGENDAMENTO' || perfil.codigo === 'EXTERNO' || perfil.codigo === 'PREFEITURA') &&
        this.justPerfilInterno(this.usuario.perfis)
      ) {
        this.resetEndereco()
      }
    }

  },

  watch: {

    'usuario.perfis': {

      handler () {
        if (this.usuario.perfis.length > 0 && this.justPerfilInterno(this.usuario.perfis) && this.hasSomeOneExterno(this.usuario.perfis) === false) {
          this.disableEndereco = true
          this.usuario.pessoa.endereco = { ...this.enderecoIterpa }
          this.usuario.pessoa.endereco.id = null
          this.codigoEstadoIterpa = this.enderecoIterpa.uf
          this.municipioIterpa = this.enderecoIterpa.municipio
        } else {
          this.disableEndereco = false
          if (!this.isEdicao && this.justPerfilInterno(this.usuario.perfis)) {
            this.codigoEstadoIterpa = null
            this.municipioIterpa = null
            this.resetEndereco()
          }
        }
      }
    }
  }
}

</script>

<style lang="scss">

  .card {
    margin: 0 3%;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }

  .footer {
    justify-content: space-between;
  }

  .cancelarButton:hover, .cancelarButton:focus {
    background-color:#fef0f0;
    color: #f56c6c;
    border-color: #fbc4c4;
  }

  .margin-top-15 {
    margin-top: 15px;
  }

  .content-route-view {
    padding: 15px 40px;
  }

  @media (max-width: 750px) {
    .el-row {
      display: flex;
      flex-direction: column;
    }

    .boxInput {
      width: 75%;
    }

    .footer {
      flex-direction: row !important;
    }
  }

  @media (max-width: 1256px) {
    .content-route-view {
      padding: 10px 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/CadastroUsuario.vue